"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/* eslint-disable valid-jsdoc */
/* eslint-disable guard-for-in */
/* eslint-disable no-empty */
/* eslint-disable no-empty-function */
/* eslint-disable no-unused-vars */
/* eslint-disable sort-imports */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParserCollection = void 0;
/**
 * A collection of all static ParserObjects.
 * The properties on this object are populated at runtime as the parsers are loaded.
 * We do this to avoid circular dependencies.
 **/
class ParserCollection {
}
exports.ParserCollection = ParserCollection;
//# sourceMappingURL=parserCollection.js.map